import { Avatar, Box, Chip } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeMachineAdminThunk } from "store/reducers/machine_func/machineAssignments";
import addURLPrefix from "utils/addURLPrefix";

const AssignedAdmins = ({ machine_admins, machine_id }) => {
  const dispatch = useDispatch();
  const machineAdminRemoveLoading = useSelector(
    (state) => state.vending.machineAdminRemoveLoading
  );
  const deleteAdmin = (admin) => {
    dispatch(
      removeMachineAdminThunk({ machine_admin: admin.id, machine: machine_id })
    );
  };
  return (
    <Box>
      {machine_admins.map((admin) => (
        <Chip
          key={admin.id}
          avatar={
            admin.photo ? (
              <Avatar alt="Admin photo" src={addURLPrefix(admin.photo)} />
            ) : (
              <Avatar>{admin.first_name[0]}</Avatar>
            )
          }
          label={`${admin.first_name} ${admin.last_name}`}
          margin={2}
          {...(!machineAdminRemoveLoading[admin.id] && {
            onDelete: () => deleteAdmin(admin),
          })}
        />
      ))}
    </Box>
  );
};

export default AssignedAdmins;
